let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("l4jQI")).then(() => parcelRequire('3x1Hb'));